/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Sp } from './Sp';

class ShopStoreBuyerLevel extends Sp {
    constructor() {
        super();
        this.baseUrl += '/shopStoreBuyerLevel';
    }

    data({ storeId, levelName, isAvailable, currentPage, pageSize } = {}) {
        return super.get('/data', {
            storeId,
            levelName,
            isAvailable,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id }).then(json => {
            const { levelIcon } = json.data.data;
            const { fileBasePath } = json.data.data;
            if (!levelIcon) {
                json.data.data.levelIcon = [];
            } else {
                json.data.data.levelIcon = levelIcon.split(',').reduce((prev, curr) => {
                    prev.push({
                        name: curr,
                        address: fileBasePath + curr,
                    });
                    return prev;
                }, []);
            }
            return json;
        });
    }

    save({
        id,
        storeId,
        levelName,
        levelCode,
        levelDesc,
        levelIcon,
        orderNum,
        isAvailable,
        isDefault,
        isGainGrowthValue,
        isGrowthValueUpgrade,
        gradeGrowthValue,
        growthValueRatio,
        buyerDiscount,
    } = {}) {
        const levelIconStr = levelIcon
            .reduce((prev, curr) => {
                prev.push(curr.name);
                return prev;
            }, [])
            .join(',');
        return super.post('/save', {
            id,
            storeId,
            levelName,
            levelCode,
            levelDesc,
            levelIcon: levelIconStr,
            orderNum,
            isAvailable,
            isDefault,
            isGainGrowthValue,
            isGrowthValueUpgrade,
            gradeGrowthValue,
            growthValueRatio,
            buyerDiscount,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    status({ id, isAvailable }) {
        return super.post('/status', {
            id,
            isAvailable,
        });
    }

    isDefault({ id, isDefault }) {
        return super.post('/isDefault', {
            id,
            isDefault,
        });
    }

    select({ storeId }) {
        return super.get('/select', { storeId });
    }
}

export default new ShopStoreBuyerLevel();
export { ShopStoreBuyerLevel };
